<input type="text" class="form-control" [ngClass]="{ 'is-touched': item, 'opacity-50': isLoading }"
  name="itemName" [(ngModel)]="itemName"
  autocomplete="off" placeholder="Last name" onClick="this.select()" #searchInput>
<span class="fa input-icon" [ngClass]="{'fa-search': !isLoading, 'fa-circle-o-notch fa-spin': isLoading }"></span>
<div class="dropdown">
  @if (!hideMenu) {
    <div class="dropdown-menu" [ngClass]="{'d-block': itemsFound.length }">
      @for (item of itemsFound; track item) {
        <a class="dropdown-item" (click)="selectItem(item)">
          {{item.firstName}} {{item.lastName}}
        </a>
      }
    </div>
  }
</div>